import { useState, useEffect } from "react";

const COOKIE_KEY = "biro_cookie_consent";

export default function CookieConsent() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_KEY);
        if (!consent) {
            const timer = setTimeout(() => setShow(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(COOKIE_KEY, "accepted");
        setShow(false);
    };

    if (!show) return null;

    return (
        <div data-testid="cookie-consent" className="fixed bottom-0 left-0 right-0 z-[60] bg-white border-t border-neutral-200 shadow-lg p-4 md:p-6">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex-1">
                    <p className="text-sm text-neutral-700">
                        Vi använder cookies för att förbättra din upplevelse. Genom att fortsätta använda webbplatsen godkänner du vår{" "}
                        <a href="/privacy-policy" className="underline text-black">integritetspolicy</a>.
                    </p>
                </div>
                <div className="flex gap-3">
                    <button data-testid="cookie-accept-btn" onClick={accept}
                        className="bg-black text-white px-6 py-2 text-xs uppercase tracking-[0.15em] font-medium hover:bg-neutral-800 transition-colors">
                        Acceptera
                    </button>
                </div>
            </div>
        </div>
    );
}
